const React = require('react');
const PropTypes = require('prop-types');
const {
    CartesianGrid,
    ComposedChart,
    XAxis,
    YAxis,
    ReferenceLine,
    ResponsiveContainer,
} = require('recharts');
const moment = require('moment');
require('./YearlyBarsLinesChart.scss');

const filterUnique = require('utilities/filterUnique');

const injectYear = (data, dateKey) =>
    data.map(d => ({ ...d, year: moment(d[dateKey]).year() }));

const YearlyBarsLinesChart = ({
    children,
    data,
    dateFormatter,
    dateKey,
    height,
    tickFormatter,
    width,
}) => {
    const dataWithYear = data ? injectYear(data, dateKey) : null;

    return (
        <ResponsiveContainer
            className="yearly-bars-lines-chart"
            height={height}
            width={width}
        >
            <ComposedChart data={dataWithYear} stackOffset="sign">
                <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
                {dataWithYear && (
                    <XAxis
                        dataKey="year"
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        tickMargin={10}
                        tickFormatter={dateFormatter}
                        ticks={dataWithYear
                            .map(d => d.year)
                            .filter(filterUnique)}
                        type="category"
                    />
                )}
                <YAxis
                    width={70}
                    tickLine={false}
                    tick={{ fontSize: 12 }}
                    type="number"
                    tickFormatter={tickFormatter}
                    tickMargin={10}
                />
                <ReferenceLine stroke="#eee" y={0} />
                {children}
            </ComposedChart>
        </ResponsiveContainer>
    );
};

YearlyBarsLinesChart.defaultProps = {
    dateFormatter: d => d,
    dateKey: 'date',
    height: '100%',
    width: '100%',
};

YearlyBarsLinesChart.propTypes = {
    children: PropTypes.node.isRequired,
    data: PropTypes.array.isRequired,
    dateFormatter: PropTypes.func,
    dateKey: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tickFormatter: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

module.exports = YearlyBarsLinesChart;
